export type AudienceStageMetadata = {
  titleFont?: string | null
  selectedCoverPhotoIndex?: number | null
  coverPhotoOptions?: Array<{ url: string; thumbnailUrl?: string }> | null
} | null | undefined

export type AudiencePresentationSource = {
  coverImageUrl?: string | null
  stageMetadata?: AudienceStageMetadata
} | null | undefined

function normalizeSelectedCoverIndex(
  selectedCoverPhotoIndex: number | null | undefined,
  optionCount: number,
) {
  if (optionCount === 0) return null
  if (
    typeof selectedCoverPhotoIndex !== 'number' ||
    !Number.isInteger(selectedCoverPhotoIndex)
  ) {
    return 0
  }
  return Math.min(Math.max(selectedCoverPhotoIndex, 0), optionCount - 1)
}

export function resolveAudiencePersistedCoverUrl(
  source: AudiencePresentationSource,
) {
  const coverPhotoOptions =
    source?.stageMetadata?.coverPhotoOptions?.filter(
      (option): option is { url: string; thumbnailUrl?: string } =>
        typeof option?.url === 'string' && option.url.trim().length > 0,
    ) ?? []
  const selectedCoverIndex = normalizeSelectedCoverIndex(
    source?.stageMetadata?.selectedCoverPhotoIndex,
    coverPhotoOptions.length,
  )
  return selectedCoverIndex == null
    ? null
    : coverPhotoOptions[selectedCoverIndex]?.url ?? null
}

export function resolveAudienceCanonicalCoverUrl(
  source: AudiencePresentationSource,
) {
  return (
    resolveAudiencePersistedCoverUrl(source) ??
    source?.coverImageUrl ??
    null
  )
}
